import { Component, OnInit, Input, ViewChild, SimpleChanges, Output, EventEmitter } from "@angular/core";
import {
	FormBuilder,
	FormGroup,
	Validators,
	FormControl
} from "@angular/forms";
import { UsersService } from "@app/api/users.service";
import { Router, ActivatedRoute } from "@angular/router";

import { Observable, Subscription, from } from 'rxjs';
import { startWith, map, filter } from 'rxjs/operators';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDialog, MatDialogRef, MatDatepickerInputEvent } from '@angular/material';

import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
// Components
import { UserImageModalComponent } from '../subs/../user-image-modal/user-image-modal.component';

//model
import {User} from '../../../../../model/user';
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

//Toast
import{ToastrService} from 'ngx-toastr';

//environment
import{environment} from '../../../../../../environments/environment';
import { SubHeaderButtonService } from '@app/services/sub-header-button.service';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
	parse: {
	  dateInput: ['DD-MM-YYYY'],
	},
	display: {
	  dateInput: 'DD-MM-YYYY',
	  monthYearLabel: 'MMM YYYY',
	  dateA11yLabel: 'LL',
	  monthYearA11yLabel: 'MMMM-YYYY',
	},
  };

  const AVAILABLE_CITY: string[] =['TP HCM', 'Hà Nội', 'Hải Phòng', 'Đà Nẵng', 'Cần Thơ', 'Đồng Nai', 'Bình Định', 'Bình Phước', 'Đắk Lắk', 'Đồng Tháp', 'Gia Lai',	'Hải Dương', 'Khánh Hòa', 'Long An', 'Quảng Bình', 'Quảng Ngãi', 'Quảng Trị', 'Thừa Thiên Huế', 'Vĩnh Long', 'Yên Bái', 'Phú Yên'];

  const AVAILABLE_ETHNIC: string[] =['Kinh', 'Tày', 'Thái', 'Mường', 'Khmer', 'Hoa', 'Nùng', "H'Mông", 'Dao', 'Gia Rai', 'Gia Rai',	'Ba Na', 'Sán Chay', 'Chăm', 'Cơ ho', 'Xơ Đăng', 'Sán Dìu', 'Hrê', 'Cơ Tu', 'Chơ Ro', 'Brâu'];

  const AVAILABLE_RELIGION: string[] =['Không', 'Phật giáo', 'Thiên chúa giáo', 'Đạo cao đài', 'Đạo hòa hảo', 'Đạo tin lành', 'Đạo hồi'];

@Component({
	selector: "kt-basic-information",
	templateUrl: "./basic-information.component.html",
	styleUrls: ["./basic-information.component.scss"],
	providers: [
		// {provide: DateAdapter, useClass: AppDateAdapter},
		// {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
		},
		{provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
	  ]
})
export class BasicInformationComponent implements OnInit {
	userCreate:User;
	oldUser: User;
	// Private properties
	private subscriptions: Subscription[] = [];
	hasFormErrors = false;

	date = new FormControl(moment());


	@Input() isSubmitted: boolean = false;
	@Input() eventReset: boolean = false;
	@Output() Submitted = new EventEmitter<boolean>()
	@Output() UserName = new EventEmitter<string>()


	lstGender=[];
	filteredCitysBD: Observable<string[]>;
	filteredCitysID: Observable<string[]>;
	filteredEthnics: Observable<string[]>;
	filteredReligion: Observable<string[]>;
	userForm: FormGroup;
	avatar:string= './assets/media/users/default.jpg';

	imageDialogRef: MatDialogRef<UserImageModalComponent>;
	UserID:null;
	oUser:any=[];
	oldDataUser:any;
	btnSave:string = "Lưu";

	lstWorkingShift:any=[];


	constructor(
		private userService: UsersService,
		private router: Router,

		private userFB: FormBuilder,
		private activatedRoute: ActivatedRoute,
		public dialog: MatDialog,
		private Toast: ToastrService,
		private route: ActivatedRoute,
		public subHeaderButtonService: SubHeaderButtonService,
		) {}

	ngOnChanges(_changes: SimpleChanges) {
		if (this.isSubmitted) {
			this.onSubmit();
		}
	}

	formatDate(date){
		if(date == null || date == undefined){
			return date;
		}
		let dateformat = moment.utc(date).toDate();
		return moment(dateformat).format("YYYY-MM-DD")
	}

	ngOnInit() {
		this.lstGender=[{id:true, name:"Nam"}, {id:false, name:"Nữ"}];
		this.createForm();
		this.lstWorkingShift = [14,1];

		if (this.route.snapshot.params.id != null && this.route.snapshot.params.id !== '') {
			this.UserID = this.route.snapshot.params.id;
			this.GetUserByID(this.UserID);
			this.btnSave = "Cập nhật";
		} else{
			this.btnSave = "Tạo mới";
		}

		this.initServiceSubheaderbtn();

	}

	ngOnDestroy() {
		this.subscriptions.forEach(sb => sb.unsubscribe());
		//this.subHeaderButtonService.setButtonCollection([]);
	}

	initServiceSubheaderbtn(){
		this.subHeaderButtonService.setButtonCollection([
			{
				name: "add-edit",
				type: "Text",
				icon: "flaticon-download-1",
				label: this.btnSave,
				Code: "Submit"
			}
		]);
		this.subscriptions.push(
			this.subHeaderButtonService.onClickButton.subscribe(code => {
				switch (code) {
					case "Submit":
						this.onSubmit();
						break;
					default:
						break;
				}
			})
		)
	}

	GetUserByID(UserID){
		this.userService.apiUsersIdGet(UserID).subscribe(res => {
			if (res.success) {
				res.data.birthday = this.formatDate(res.data.birthday);
				res.data.passport_expired = this.formatDate(res.data.passport_expired);
				res.data.id_card_issue_date = this.formatDate(res.data.id_card_issue_date);
				res.data.passport_date = this.formatDate(res.data.passport_date);
				res.data.avatar = environment.backendhost + res.data.avatar;
				this.oUser = res.data;
				this.avatar = this.oUser.avatar;
				this.oldDataUser = res.data;

				let fullName:string;
				if(this.oUser.middle_name != null){
					fullName = this.oUser.last_name +' '+ this.oUser.middle_name + ' ' + this.oUser.first_name;
				} else {
					fullName = this.oUser.last_name +' '+ this.oUser.first_name;
				}
				this.UserName.emit(fullName + " (" + this.oUser.employee_code + ")");
			} else {

			}

		})
	}


	dataURItoBlob(Base64) {
		var dataURI = Base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
		const byteString = window.atob(dataURI);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
		  int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: 'image/jpeg' });
		return blob;
	 }

	convertImageFile(base64, usercode){
		let iRandom = Math.floor(Math.random() * (10000 - 10 + 1)) + 10;
		let date = new Date().valueOf();
		let imageName = '[avatar]' + '['+date +']'+'['+ usercode + ']'+'.jpeg';
		// call method that creates a blob from dataUri
		let imageBlob = this.dataURItoBlob(base64);
		let imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
		return imageFile;
	}
	getValue(e){
		this.lstWorkingShift = e;
	}

	onSubmit() {
		this.Submitted.emit(false);

		//Show all error message
		this.hasFormErrors = false;
		const controls = this.userForm.controls;
		/** check form */
		if (this.userForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}
		//API
			if(this.UserID == null ||this.UserID == undefined ){
				try {
					this.userService.apiUsersPost(this.userForm.value).subscribe(res => {
						if (res.success) {
							if(this.avatar != './assets/media/users/default.jpg'){
								let BlobAvatar = this.convertImageFile(this.avatar, this.userForm.value.employee_code);
								this.userService.apiUsersIdUploadAvatarPut(res.data.id, BlobAvatar).subscribe(res =>{
								})
							}
							this.Toast.success("Thêm mới người dùng thành công", "Thao tác thành công");
							this.router.navigate(['portal/hr/user-management/edit/'+ res.data.id,]);

						} else {
							this.Toast.error("Thêm mới người dùng không thành công", "Thao tác không thành công", {timeOut:3000});
						}
					});
				} catch (error) {
					this.Toast.error("Thêm mới người dùng không thành công", "Thao tác không thành công", {timeOut:3000});
				}

			} else {
				try {
					this.userForm.value.birthday = this.convertDatePut(this.userForm.value.birthday);
					this.userForm.value.passport_expired = this.convertDatePut(this.userForm.value.passport_expired);
					this.userForm.value.id_card_issue_date = this.convertDatePut(this.userForm.value.id_card_issue_date);
					this.userForm.value.passport_date = this.convertDatePut(this.userForm.value.passport_date);
					this.userService.apiUsersIdPut(this.UserID, this.userForm.value).subscribe(res =>{
						if(res.success){
							if(this.avatar != './assets/media/users/default.jpg' && this.avatar != this.oldDataUser.avatar ){
								let BlobAvatar = this.convertImageFile(this.avatar, this.userForm.value.employee_code);
								this.userService.apiUsersIdUploadAvatarPut(res.data.id, BlobAvatar).subscribe(res =>{
								})
							} 
							let fullName:string;
							if(res.data.middle_name != null){
								fullName = res.data.last_name +' '+ res.data.middle_name + ' ' + res.data.first_name;
							} else {
								fullName = res.data.last_name +' '+ res.data.first_name;
							}
							this.UserName.emit(fullName + " (" + res.data.employee_code + ")");

							this.Toast.success("Chỉnh sửa thông tin người dùng thành công", "Thao tác thành công");
						}
					})
				} catch (error) {
					this.Toast.error("Cập nhập thông tin người dùng không thành công", "Thao tác không thành công", {timeOut:3000});
				}

			}





	}


	createForm() {
	// Public properties
		this.userForm = new FormGroup({
			employee_code: new FormControl(null,[Validators.required]),
			email: new FormControl(null,[Validators.required, Validators.email]),
			first_name: new FormControl(null,[Validators.required]),
			middle_name: new FormControl(),
			last_name: new FormControl(null,[Validators.required]),
			cell_phone: new FormControl(),
			gender: new FormControl(),
			birthday: new FormControl(),
			birthplace: new FormControl(),
			nationality: new FormControl(),
			id_card_number: new FormControl(),
			id_card_issue_date: new FormControl(),
			id_card_issue_palce: new FormControl(),
			passport_id: new FormControl(),
			passport_expired: new FormControl(),
			ethnic: new FormControl(), //Dan toc
			religion: new FormControl(),
			passport_date: new FormControl(),
			domicile: new FormControl(),
			personal_tax_code: new FormControl(),
			passport_place_of_issue: new FormControl(),
			attendance_code: new FormControl()
		});
		this.filteredCitysBD = this.userForm.controls.birthplace.valueChanges
			.pipe(
				startWith(''),
				map(val => this.filterCityBD(val != null ? val.toString() : null))
		);

		this.filteredCitysID = this.userForm.controls.id_card_issue_palce.valueChanges
			.pipe(
				startWith(''),
				map(val => this.filterCityID(val != null ? val.toString() : null))
		);

		this.filteredEthnics = this.userForm.controls.ethnic.valueChanges
			.pipe(
				startWith(''),
				map(val => this.filterEthnic(val != null ? val.toString() : null))
		);

		this.filteredReligion = this.userForm.controls.religion.valueChanges
			.pipe(
				startWith(''),
				map(val => this.filterReligion(val != null ? val.toString() : null))
		);
	}

	filterCityBD(val: string): string[] {
		return AVAILABLE_CITY.filter(option =>
			option.toLowerCase().includes(val != null ? val.toLowerCase() : null));
	}

	filterCityID(val: string): string[] {
		return AVAILABLE_CITY.filter(option =>
			option.toLowerCase().includes(val != null ? val.toLowerCase() : null));
	}

	filterEthnic(val: string): string[] {
		return AVAILABLE_ETHNIC.filter(option =>
			option.toLowerCase().includes(val != null ? val.toLowerCase() : null));
	}

	filterReligion(val: string): string[] {
		return AVAILABLE_RELIGION.filter(option =>
			option.toLowerCase().includes(val != null ? val.toLowerCase() : null));
	}

	// /**
	//  * Reset
	//  */
	// reset() {
	// 	this.userCreate = Object.assign({}, this.oldUser);
	// 	this.userForm.reset();
	// 	this.createForm();
	// 	this.userForm.markAsPristine();
	// 	this.userForm.markAsUntouched();
	// 	this.userForm.updateValueAndValidity();
	// }

	openModalImage() {
		let  dialogRef = this.dialog.open(UserImageModalComponent, {data: {image: null}});
		let dialogSubmitSubscription = dialogRef.afterClosed().subscribe(result => {
			if(!!!result){
				return;
			}
			if(result.data != null){
				this.avatar = result.data.dataURL;
			}

			dialogSubmitSubscription.unsubscribe();
		  });
	}

	convertDatePut(date){
		try {
			return moment.utc(date).toDate();
		} catch (error) {
			return date;
		}
	}

}
